import React, { useEffect, useMemo } from "react";
import Pagination from "react-bootstrap/Pagination";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import StatusFormatter from "./StatusFormatter";
import { headerStyle } from "../../../assets/css/customStyle";
import { useDispatch, useSelector } from "react-redux";
import { searchUser, tablePageUser, tableSizePerPageUser } from "../../../Redux/Action/Users";
import { pageSizeOptions } from "../../../Services/Constant/Constant";

const TableComponent = ({ Users }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userTable = useSelector((store) => store.Users);

  const rows = Users?.data?.responseData || [];
  const searchText = userTable.searchText || "";
  const sizePerPage = userTable.sizePerPage || 10;
  const page = userTable.page || 1;

  const filteredRows = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return rows;

    return rows.filter((r) => {
      const name = (r.full_name || "").toLowerCase();
      const email = (r.email || "").toLowerCase();
      const appType = String(r.app_type ?? "").toLowerCase();
      return name.includes(q) || email.includes(q) || appType.includes(q);
    });
  }, [rows, searchText]);

  const totalRecords = filteredRows.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / sizePerPage));
  const safePage = Math.min(Math.max(page, 1), totalPages);

  useEffect(() => {
    if (page !== safePage) {
      dispatch(tablePageUser(safePage));
    }
  }, [dispatch, page, safePage]);

  const pageData = useMemo(() => {
    const start = (safePage - 1) * sizePerPage;
    const end = start + sizePerPage;
    return filteredRows.slice(start, end);
  }, [filteredRows, safePage, sizePerPage]);

  const from = totalRecords === 0 ? 0 : (safePage - 1) * sizePerPage + 1;
  const to = Math.min(safePage * sizePerPage, totalRecords);

  const handleSearchChange = (e) => {
    dispatch(searchUser(e.target.value));
    dispatch(tablePageUser(1));
  };

  const handlePageSizeChange = (e) => {
    dispatch(tableSizePerPageUser(Number(e.target.value)));
    dispatch(tablePageUser(1));
  };

  const maxPageCount = 5;
  const paginationItems = [];
  let startPage = Math.max(safePage - Math.floor(maxPageCount / 2), 1);
  let endPage = Math.min(startPage + maxPageCount - 1, totalPages);
  if (endPage - startPage < maxPageCount - 1) {
    startPage = Math.max(endPage - maxPageCount + 1, 1);
  }
  for (let p = startPage; p <= endPage; p++) {
    paginationItems.push(
      <Pagination.Item key={p} active={p === safePage} onClick={() => dispatch(tablePageUser(p))}>
        {p}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <div className="table-search-bar">
        <div className="total-user-table">
          Show
          <select
            onChange={handlePageSizeChange}
            className="form-control d-inline-block page-drop-down"
            value={sizePerPage}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size} style={{ backgroundColor: "white", color: "black" }}>
                {size}
              </option>
            ))}
          </select>
          entries
        </div>

        <div className="search-table">
          <input
            className="form-control"
            placeholder="Search"
            type="text"
            value={searchText}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className="react-bootstrap-table react-event-table-class">
        <Table bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th style={{ width: "10%", ...headerStyle }}>Sr no</th>
              <th style={{ width: "30%", ...headerStyle }}>Name</th>
              <th style={{ width: "30%", ...headerStyle }}>Email</th>
              <th style={{ width: "10%", ...headerStyle }}>App Type</th>
              <th style={{ ...headerStyle }}>Enable/Disable</th>
            </tr>
          </thead>
          <tbody>
            {pageData.length > 0 ? (
              pageData.map((row, idx) => (
                <tr key={row.user_id ?? `${row.email ?? idx}`} className="table-bg-col">
                  <td>{from + idx}</td>
                  <td>
                    <h6 onClick={() => navigate(`profile/${row.user_id}`)} className="event-title-open mb-0">
                      {row.full_name}
                    </h6>
                  </td>
                  <td>{row.email}</td>
                  <td>{row.app_type}</td>
                  <td>
                    <StatusFormatter cell={row.disabled} row={row} />
                  </td>
                </tr>
              ))
            ) : (
              <tr className="table-bg-col">
                <td colSpan={5} className="text-center">
                  No Result Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="pagination-event">
        <div>
          <span>
            {totalRecords === 0 ? "No users to display" : `Showing users ${from} to ${to} of ${totalRecords}`}
          </span>
        </div>
        <div className="pagination-no">
          <Pagination className="mb-0">
            {safePage > 1 && (
              <Pagination.Prev onClick={() => dispatch(tablePageUser(safePage - 1))}>Previous</Pagination.Prev>
            )}
            {paginationItems}
            {safePage < totalPages && (
              <Pagination.Next onClick={() => dispatch(tablePageUser(safePage + 1))}>Next</Pagination.Next>
            )}
          </Pagination>
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
